import $ from 'jquery'
import React from 'react'
import { getQueryDescription } from "./SearchLink";


function BriefTitle({columns}) {

    let text = "";

    for (let x=0; x<columns.length; ++x) {
        let column_text = "";
        for (let y=0; y<columns[x].length; ++y) {
            const widget = columns[x][y];
            if (widget.value.length) {
                let query_str = getQueryDescription(
                    widget.model, widget.field, widget.value,
                    column_text.length < 1
                    );
                if (column_text.length)
                    query_str = "oder " + query_str;
                column_text += " " + query_str;
            }
        }
        if (column_text.length) {
            if (text.length)
                text += " und";
            text += column_text;
        }
    }

    if (!text.length)
        text = "Kein Suchkriterium ausgewählt";
    else
        text = "Zitate" + text;

    return (
        <h3>{text}</h3>
    );
}

export default BriefTitle


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/BriefTitle.js